<div class="row space-between align-center gap-24">
  <h2>Organisations</h2>

  <rr-btn size="Small" type="Primary" iconStart="add" (click)="addNewCompany()"
    >new Organisation</rr-btn
  >
</div>
<div class="filter col space-between gap-24">
  <rr-input
    type="search"
    placeholder="Search"
    [FormControl]="searchQuery"
  ></rr-input>
  <div class="companytypefilter row gap-8">
    <rr-checkbox
      *ngFor="let c of companyTypes"
      (click)="onFilterTypeChange(c.id, chb.checked)"
      #chb
      >{{ c.name }}</rr-checkbox
    >
  </div>
</div>
<div class="wrapper">
  <div class="companylist w100 col gap-8">
    <div class="pagination-container">
        <mat-paginator
            (page)="handlePageEvent($event)"
            [length]="length"
            [pageSize]="pageSize"
            [showFirstLastButtons]="true"
            [pageSizeOptions]="pageSizeOptions"
            [hidePageSize]="false"
            [pageIndex]="pageIndex">
        </mat-paginator>
    </div>
        @if (companiesList.length === 0) {
            <p class="text-center w100" i18n>No companies are matching your request</p>
        }
    <div
      class="row companyitem gap-8 w100 status-{{ company.status }}"
      *ngFor="let company of companiesList"
    >
      <app-company-logo [company]="company" class="logo"></app-company-logo>
      <div class="name">{{ company.name ? company.name : "No name" }}</div>
      <div class="col">
        <div class="row gap-8">
          <rr-badge
            *ngIf="company.companyTypeId"
            [tone]="
              company.companyTypeId == 'dBvJIh-H'
                ? 'information'
                : company.companyTypeId == 'Zq4RfVbN'
                ? 'brand'
                : company.companyTypeId == '9FnB5tXz'
                ? 'warning'
                : company.companyTypeId == '9FnB5tXz'
                ? 'success'
                : 'nutral'
            "
            >{{ company.companyTypeName }}</rr-badge
          >
          <rr-badge *ngIf="company.industryId">{{
            company.industryId | getIndustryNameById | async
          }}</rr-badge>
        </div>
        <div class="row gap-4">
          <div class="small" title="Creation Date">
            CD: {{ company.dateCreated | getLocaldateByTime }}
          </div>
          |
          <div class="small" title="Last Update Date">
            LU:
            {{
              company.dateUpdated
                ? (company.dateUpdated | getLocaldateByTime)
                : "--"
            }}
          </div>
        </div>
      </div>
      <div class="btns row grow-1 gap-8 h100">
        <rr-btn type="link" size="Small" iconStart="trash">Delete</rr-btn>
        <rr-btn
          type="link"
          size="Small"
          iconStart="edit"
          (click)="addNewCompany(company)"
          >Edit</rr-btn
        >
        <rr-btn
          type="Secondary"
          size="Small"
          iconStart="user"
          (click)="showUsers(company)"
          >Details</rr-btn
        >
        <rr-btn
          type="Secondary"
          size="Small"
          iconStart="add"
          (click)="addSubCompany(company)"
          >Sub-Orga</rr-btn
        >
      </div>
    </div>
    <div class="pagination-container">
        <mat-paginator
            (page)="handlePageEvent($event)"
            [length]="length"
            [pageSize]="pageSize"
            [showFirstLastButtons]="true"
            [pageSizeOptions]="pageSizeOptions"
            [hidePageSize]="false"
            [pageIndex]="pageIndex">
        </mat-paginator>
    </div>
  </div>
</div>

